var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerticalDotMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5521_19665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 10.0013C9.1665 10.2223 9.2543 10.4343 9.41058 10.5906C9.56686 10.7468 9.77882 10.8346 9.99984 10.8346C10.2209 10.8346 10.4328 10.7468 10.5891 10.5906C10.7454 10.4343 10.8332 10.2223 10.8332 10.0013C10.8332 9.78029 10.7454 9.56833 10.5891 9.41205C10.4328 9.25577 10.2209 9.16797 9.99984 9.16797C9.77882 9.16797 9.56686 9.25577 9.41058 9.41205C9.2543 9.56833 9.1665 9.78029 9.1665 10.0013Z",
    stroke: "#7A7A7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 15.8333C9.1665 16.0543 9.2543 16.2663 9.41058 16.4226C9.56686 16.5789 9.77882 16.6667 9.99984 16.6667C10.2209 16.6667 10.4328 16.5789 10.5891 16.4226C10.7454 16.2663 10.8332 16.0543 10.8332 15.8333C10.8332 15.6123 10.7454 15.4004 10.5891 15.2441C10.4328 15.0878 10.2209 15 9.99984 15C9.77882 15 9.56686 15.0878 9.41058 15.2441C9.2543 15.4004 9.1665 15.6123 9.1665 15.8333Z",
    stroke: "#7A7A7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 4.16536C9.1665 4.38638 9.2543 4.59834 9.41058 4.75462C9.56686 4.9109 9.77882 4.9987 9.99984 4.9987C10.2209 4.9987 10.4328 4.9109 10.5891 4.75462C10.7454 4.59834 10.8332 4.38638 10.8332 4.16536C10.8332 3.94435 10.7454 3.73239 10.5891 3.57611C10.4328 3.41983 10.2209 3.33203 9.99984 3.33203C9.77882 3.33203 9.56686 3.41983 9.41058 3.57611C9.2543 3.73239 9.1665 3.94435 9.1665 4.16536Z",
    stroke: "#7A7A7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5521_19665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDotMenu);
export default __webpack_public_path__ + "static/media/vertical-dot-menu.ce9305498669b39fbd7458102ffdd7f3.svg";
export { ForwardRef as ReactComponent };